import React from 'react';

import { Helmet } from 'react-helmet';
import { Link } from '~/lib/react-router-dom';

import { Box, Container, Tab, Tabs } from '@mui/material';

import { expandTabRoutes, preRegisterSpotlightRoutes } from '~/components/Common/Spotlight/SpotlightProvider';

import PageHeader from '../Common/Elements/PageHeader';

import { InvoiceToolsTab, invoiceToolsTabs, invoiceToolsTabsList } from './InvoiceToolsTabs';

preRegisterSpotlightRoutes(expandTabRoutes('/invoice-tools', 'Invoice Tools', invoiceToolsTabs));

interface InvoiceToolsPageContainerProps {
  match: {
    params: { tab: InvoiceToolsTab };
  };
}

export default function InvoiceToolsPageContainer({
  match: {
    params: { tab },
  },
}: InvoiceToolsPageContainerProps) {
  const currentTab = invoiceToolsTabs[tab];
  const index = invoiceToolsTabsList.indexOf(tab);
  const title = `Invoice Tools / ${currentTab.title}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container maxWidth="xl">
        <PageHeader title={title} />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={index} variant="scrollable">
            {invoiceToolsTabsList.map((tabKey, tabIndex) => (
              <Tab
                key={tabKey}
                value={tabIndex}
                label={invoiceToolsTabs[tabKey as InvoiceToolsTab].title}
                to={`/invoice-tools/${tabKey}`}
                component={Link}
              />
            ))}
          </Tabs>
        </Box>

        <Box mt={4}>
          <Box component={currentTab.component} />
        </Box>
      </Container>
    </>
  );
}
